import debounce from 'lodash.debounce'

export default {
  inserted: function(el) {
    el.addEventListener('mouseover', event => {
      const $qlEditor = el.querySelector('.ql-editor')
      const $p = $qlEditor.querySelector('p')

      if (event.target.tagName === 'A') {
        $p.classList.add('no-overflow')
        $qlEditor.classList.add('no-overflow')
      }
    })

    const removeClass = debounce(event => {
      const $qlEditor = el.querySelector('.ql-editor')
      const $p = $qlEditor.querySelector('p')

      if (event.target.tagName !== 'A') {
        $p.classList.remove('no-overflow')
        $qlEditor.classList.remove('no-overflow')
      }
    }, 100)

    el.addEventListener('mousemove', removeClass)
  },
}
